import { Navigate } from 'react-router-dom';
import useAuthStore from '../../stores/authStore';

const ProtectedRoute = ({ children, requireProfile = false }) => {
  const { isAuthenticated, profile, loading } = useAuthStore();

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Redirect to auth if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // If profile is required but not completed, redirect to profile steps
  if (requireProfile && (!profile?.profileCompleted)) {
    // Check what profile data exists to determine which step to show
    const hasBasicInfo = profile?.county && profile?.mpesaNumber && 
                        profile?.nationalId && profile?.gender;
    
    if (hasBasicInfo) {
      return <Navigate to="/profile-step-2" replace />;
    } else {
      return <Navigate to="/profile-step-1" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;